exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".y9OSX {\n  cursor: pointer;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.y9OSX ._1JWHd {\n  padding-right: 30px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "y9OSX",
	"whCode": "_1JWHd"
};